import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddressWiseBeneficiary = () => {
    const navigate = useNavigate();
    const { appId, language } = useAppId();
    const lang = language || 'en';

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const location = useLocation();

    // Translations
    const t = {
        en: {
            pageTitle: "Address Wise Beneficiary",
            voters: "Voters",
            beneficiaries: "Beneficiaries",
            percent: "Percent",
            loadingData: "Loading Data...",
            noData: "No data found.",
            searchPlaceholder: "Search Address..."
        },
        hi: {
            pageTitle: "पता अनुसार लाभार्थी",
            voters: "मतदाता",
            beneficiaries: "लाभार्थी",
            percent: "प्रतिशत",
            loadingData: "डेटा लोड हो रहा है...",
            noData: "कोई डेटा नहीं मिला।", 
            searchPlaceholder: "पता खोजें..."
        },
        gu: {
            pageTitle: "સરનામું પ્રમાણે લાભાર્થી",
            voters: "Voters",
            beneficiaries: "Beneficiaries",
            percent: "Percent",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noData: "કોઈ ડેટા મળ્યો નથી.",
            searchPlaceholder: "સરનામું શોધો..."
        }
    };

    const txt = t[lang] || t.gu;

    useEffect(() => {
        if (!appId) {
            navigate('/login');
            return;
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_address_wise_beneficiary_dash`, {
                app_id: appId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                setData(response.data.data.result);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    // Filter Data based on Search Term
    const filteredData = data.filter(item => {
        const title = item.surname || item.add_eng || item.add_uni || "";
        return title.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
        <div className="address-beneficiary-page">
            <div className="header-wrapper shadow-sm">
                <Header title={txt.pageTitle} />
            </div>

            <div className="content-container container-fluid p-3 p-md-4 mx-auto">
                
                {/* Search Bar */}
                <div className="search-container mb-4 slide-up">
                    <div className="search-wrapper">
                        <input
                            className="search-input"
                            type="text"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <button className="clear-search-btn" onClick={() => setSearchTerm('')}>
                                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>

                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}></div>
                        <p className="mt-3 text-muted fw-bold">{txt.loadingData}</p>
                    </div>
                ) : filteredData.length > 0 ? (
                    <div className="row g-4" style={{ animationDelay: '0.1s' }}>
                        {filteredData.map((item, index) => {
                            // Calculations
                            const totalVoter = item.total_voter || 0;
                            const totalBen = item.total_beneficiaries || item.total_beneficiary || 0;
                            const percentage = totalVoter > 0 ? Math.round((totalBen / totalVoter) * 100) : 0;
                            const displayName = item.surname || item.add_uni || item.add_eng || "Unknown";

                            return (
                                <div className="col-12 col-md-6 col-lg-4" key={index} onClick={()=> navigate('/sel_scheme_beneficiary_by_address' , {state :{address_text:item.add_eng || item.add_uni || item.surname}})}>
                                    <div className="data-card h-100">
                                        {/* Top Section */}
                                        <div className="card-top">
                                            <div className="index-badge">
                                                {index + 1}
                                            </div>
                                            <div className="title-text">
                                                {displayName}
                                            </div>
                                            <div className="arrow-icon">
                                                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                            </div>
                                        </div>

                                        {/* Divider */}
                                        <div className="card-divider"></div>

                                        {/* Bottom Section (Stats) */}
                                        <div className="card-bottom">
                                            <div className="stat-col">
                                                <div className="stat-num text-blue">{totalVoter.toLocaleString('en-IN')}</div>
                                                <div className="stat-lbl">{txt.voters}</div>
                                            </div>
                                            
                                            <div className="stat-divider"></div>
                                            
                                            <div className="stat-col">
                                                <div className="stat-num text-green">{totalBen.toLocaleString('en-IN')}</div>
                                                <div className="stat-lbl">{txt.beneficiaries}</div>
                                            </div>
                                            
                                            <div className="stat-divider"></div>
                                            
                                            <div className="stat-col">
                                                <div className="stat-num text-orange">{percentage}%</div>
                                                <div className="stat-lbl">{txt.percent}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center p-5 bg-white rounded-4 shadow-sm border mt-3">
                        <div style={{ fontSize: '40px', opacity: 0.5, marginBottom: '10px' }}>📄</div>
                        <h5 className="text-muted m-0">{txt.noData}</h5>
                    </div>
                )}
            </div>

            <style jsx>{`
                .address-beneficiary-page { 
                    width: 100%; 
                    min-height: 100vh; 
                    background: #eef2f6; 
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; 
                    padding-bottom: 40px; 
                }
                .header-wrapper { background: white; padding: 0 24px; position: sticky; top: 0; z-index: 50; }

                /* Search Bar */
                .search-container { 
                    display: flex; 
                    justify-content: flex-end; 
                }
                .search-wrapper { 
                    position: relative; 
                    width: 100%; 
                    max-width: 400px;
                    display: flex; 
                    align-items: center; 
                    background: white; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 12px; 
                    padding: 0 16px; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02); 
                }
                .search-icon { 
                    width: 20px; 
                    height: 20px; 
                    color: #94a3b8; 
                }
                .search-input { 
                    width: 100%; 
                    border: none; 
                    padding: 14px 10px; 
                    font-size: 15px; 
                    color: #1e293b; 
                    outline: none; 
                    background: transparent; 
                }
                .clear-search-btn {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f5f9;
                    border: none;
                    border-radius: 50%;
                    padding: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    transition: all 0.2s;
                }
                .clear-search-btn:hover {
                    background: #e2e8f0;
                }

                /* Data Card Styling */
                .data-card {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #f1f5f9;
                    display: flex;
                    flex-direction: column;
                    transition: transform 0.2s, box-shadow 0.2s;
                    cursor: pointer;
                    height: 100%;
                }
                .data-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.08);
                }

                /* Card Top Section */
                .card-top {
                    display: flex;
                    align-items: center;
                    padding: 16px;
                    gap: 16px;
                }

                .index-badge {
                    width: 40px;
                    height: 40px;
                    background: #eff6ff;
                    color: #1e40af;
                    font-size: 15px;
                    font-weight: 800;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }

                .title-text {
                    flex: 1;
                    font-size: 15px;
                    font-weight: 600;
                    color: #334155;
                    line-height: 1.5;
                }

                .arrow-icon {
                    color: #94a3b8;
                    flex-shrink: 0;
                }

                /* Divider */
                .card-divider {
                    height: 1px;
                    background: #f1f5f9;
                    width: 100%;
                }

                /* Card Bottom Section */
                .card-bottom {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 16px 0;
                }

                .stat-col {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }

                .stat-divider {
                    width: 1px;
                    height: 40px;
                    background: #f1f5f9;
                }

                .stat-num {
                    font-size: 16px;
                    font-weight: 800;
                    margin-bottom: 4px;
                }

                .stat-lbl {
                    font-size: 12px;
                    font-weight: 600;
                    color: #94a3b8;
                }

                /* Colors matching the image */
                .text-blue { color: #2563eb; }
                .text-green { color: #16a34a; }
                .text-orange { color: #b45309; }

                /* Animations */
                .slide-up { animation: slideUp 0.4s ease forwards; opacity: 0; }
                @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

                /* Mobile Adjustments */
                @media (max-width: 768px) {
                    .search-container { 
                        justify-content: stretch; 
                    }
                    .search-wrapper { 
                        max-width: 100%; 
                    }
                }

                @media (max-width: 480px) {
                
                    .title-text { font-size: 14px; }
                    .index-badge { width: 36px; height: 36px; font-size: 14px; }
                    .stat-num { font-size: 14px; }
                    .stat-lbl { font-size: 10px; }
                    .card-top { padding: 12px; gap: 12px; }
                    .card-bottom { padding: 12px 0; }
                }
            `}</style>
        </div>
    );
};

export default AddressWiseBeneficiary;